import { getActiveIcon } from 'library/helpers';

const config = {
  // Source List
  source: {
    // Table Columns
    columns: [
      {
        title: 'Competency Name',
        dataIndex: 'name',
        key: 'name',
        width: '180px',
        sorter: true
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '120px',
        align: 'center',
        sorter: true,
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: 'Select Competencies',
    rowSelectionConfig: {
      selectItemOnSingleClick: true,
      selectItemOnDoubleClick: false,
      highlightRow: true,
      multiRow: true,
      toggleRow: true
    }
  },
  // Destination List
  destination: {
    // General
    columns: [
      {
        title: 'Competency Name',
        dataIndex: 'name',
        key: 'name',
        width: '180px',
        sorter: true
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '120px',
        align: 'center',
        sorter: true,
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    title: 'Assigned Competencies',
    rowSelectionConfig: {
      selectItemOnSingleClick: true,
      selectItemOnDoubleClick: false,
      highlightRow: true,
      multiRow: true,
      toggleRow: true
    }
  }
};

export default config;
